<template>
  <div>

    <div class="modal show fade modal-success text-left" style="display: block;" v-if="show">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabel120">Update Transaction Type</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="form form-horizontal">
              <div class="row">
                <div class="col-12">
                  <div class="form-group row">
                    <div class="col-sm-9 ">
                      <div class="form-group">
                        <label>Transaction Type </label>
                        <select class="form-control" v-model="selectedType">
                          <option :key="index" :value="option.id" v-for="(option, index) in transactionTypes">
                            {{option.name}}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-9 ">
                      <div class="form-group">
                        <label>Status</label>
                        <select class="form-control" v-model="selectedStatus">
                          <option :value="1">Active</option>
                          <option :value="0">Inactive</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row d-flex justify-content-end">
                    <button type="button" class="btn btn-sm btn-primary" @click="sendCall">Update</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>

export default {
  props: ['show', 'typeData'],
  data() {
    return {
      list: [],
      loader: false,
      selectedType: null,
      selectedStatus: 1,
      transactionTypes: [],
      aquiringTransactionTypeId:'',
      index:'',
      aquiringId:''
    }
  },
  mounted() {
    // this.getTransactionTypes()
  },
  methods: {
    // getTransactionTypes() {
    //   this.makeRequest(
    //       "post",
    //       "v1/transaction-types",
    //       {},
    //       {},
    //       false
    //   ).then(callResponse => {
    //     if (!callResponse.error) {
    //       let code = callResponse.response.data.code;
    //
    //       if (code == 200) {
    //         this.transactionTypes = callResponse.response.data.data
    //       }
    //     }
    //   });
    // },
    sendCall(){
      let requestData ={
        type :'update',
        aquiringTransactionTypeId :this.aquiringTransactionTypeId,
        status :this.selectedStatus,
        transactionTypeId :this.selectedType,
        aquiringId :this.aquiringId,
      }

      this.makeRequest('post', 'v1/manage-aquiring-transaction-types', requestData).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {


            var acquiringTransctionTypeStoreData = this.$store.getters.getByKey(
                "acquiringMainTransactionTypes"
            );

            if(acquiringTransctionTypeStoreData){
              acquiringTransctionTypeStoreData.row.transaction_types = callResponse.response.data.data
              this.$store.dispatch("set", acquiringTransctionTypeStoreData);
            }

            this.$emit('hide')
          }
        }

      });

    },
  },
  watch:{
    typeData(val){
      this.selectedType = val.item.pivot.transaction_type_id
      this.selectedStatus = val.item.pivot.status
      this.aquiringTransactionTypeId = val.item.pivot.id
      this.index = val.index
      this.transactionTypes = val.transactionTypes
      this.aquiringId = val.aquiringId

    }
  }
}
</script>



